import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function HeroAsesoria() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  const scrollToPlans = () => {
    document.getElementById('planes')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-[80vh] min-h-[560px] overflow-hidden bg-brand-black">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant-male-fashion-consultant-portrait-luxury-atelier-barcelona-sophisticated-man-in-tailored-dark-suit-editorial-lighting-warm-tones-minimal-background-authoritative-presence-high-end-fashion-photography-soft-grain-texture&width=1920&height=1080&seq=200&orientation=landscape"
          alt="Anthony Sánchez — Asesoría de Imagen"
          className="w-full h-full object-cover object-top opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-black via-brand-black/80 to-brand-black/40" />
      </div>
      <div className="relative z-10 h-full flex items-end pb-20 md:pb-32 px-6 lg:px-[7%]">
        <div className="w-full">
          <div
            className={`transition-all duration-1000 ease-out ${
              loaded
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-8'
            }`}
          >
            <span className="font-sans text-brand-sage text-[11px] tracking-[0.2em] uppercase font-medium">
              Sistema de Imagen Personal — Barcelona
            </span>
            <h1 className="font-serif text-white text-[clamp(2.8rem,6vw,5.5rem)] font-light leading-[1.05] mt-5 max-w-3xl">
              Esto no es moda.
              <span className="block italic text-brand-sage mt-2">
                Es estrategia personal.
              </span>
            </h1>
            <p className="font-sans text-white/70 text-base md:text-lg max-w-xl leading-relaxed mt-8">
              Anthony Sánchez diseña, organiza y optimiza tu imagen completa.
              Un sistema integral donde tu estilo se alinea con tu vida, tus
              objetivos y tu perfil psicológico.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <button
                onClick={scrollToPlans}
                className="inline-flex items-center justify-center bg-white text-brand-black font-sans text-[15px] font-medium tracking-wide px-10 py-4 rounded-full hover:bg-brand-sage transition-colors duration-300 whitespace-nowrap"
              >
                Ver planes
              </button>
              <Link
                to="/contacto"
                className="inline-flex items-center justify-center border border-white/30 text-white font-sans text-[15px] font-medium tracking-wide px-10 py-4 rounded-full hover:bg-white/10 transition-colors duration-300 whitespace-nowrap"
              >
                Solicitar evaluación
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}